import { ProductOffers } from '@vae/server/src/types/synerallApiTypes'

export const sortOfferedProducts = (products: ProductOffers): ProductOffers => {
	//TODO: Sort products by user's interests
	return products
}
